import React, { useContext, useEffect, useState } from 'react';
import Paper from '@material-ui/core/Paper';
import { makeStyles, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Button, Checkbox, FormControlLabel, Link } from '@material-ui/core';
import Espacos from '../espacos/Espacos';
import Agenda from '../agenda/Agenda';
import HorariosDisponiveis from '../horarios-disponiveis/HorariosDisponiveis';
import Snackbar from '../../Components/Common/Snackbar';
import { fetchEspacos } from '../espacos/EspacosApi';
import Fetching from '../utils/Fetching';
import LinkUtilities from './LinkUtilities';
import { Alert } from '@material-ui/lab';
import { getEmpresa, updateEmpresa } from '../configuracoes/ConfiguracoesApi'; // <-- precisa existir no backend
import { AuthContext } from '../../Components/Login';

const useStyles = makeStyles(theme => ({
  espacos: {
    marginBottom: theme.spacing(2),
  },
  warning: {
    display: 'flex',
    justifyContent: 'center',
    marginBottom: theme.spacing(2)
  },
}));

export default (props) => {

  const classes = useStyles();

  const [view, setView] = useState("agenda");

  const [espacoSelecionado, setEspacoSelecionado] = useState();
  const [espacos, setEspacos] = useState([]);
  const [addedEspaco, setAddedEspaco] = useState();
  const [deletedEspaco, setDeletedEspaco] = useState();
  const [updatedEspacos, setUpdatedEspacos] = useState([]);
  const [dadosEmpresa, setDadosEmpresa] = useState();
  const [fetching, setFetching] = useState(false);
  const [erro, setErro] = useState();
  const [showTermsPopup, setShowTermsPopup] = useState(false);
  const [accepted, setAccepted] = useState(false);

  const authContext = useContext(AuthContext);
  const empresaId = authContext.user.id;

  const limpaErro = () => {
    setErro(undefined);
  }

  useEffect(() => {
    const fetchDadosEmpresa = async() => {
      const response = await getEmpresa(empresaId);
      if (response.ok) {
        setDadosEmpresa(response.data);

        // verifica se falta aceite de termos
        if (!response.data.dataAssinatura) {
          setShowTermsPopup(true);
        }
      } else {
        setErro("Erro ao buscar dados da empresa. Contate o Administrador");
        setDadosEmpresa(undefined);
      }
    }

    fetchDadosEmpresa();
  }, [empresaId]);

  useEffect(() => {
    const getEspacos = async () => {

      setFetching(true);

      const response = await fetchEspacos();
      if (response.ok) {
        const espacos = response.data;
        setEspacos(espacos);
        
        if (espacos.length > 0) {
          setEspacoSelecionado(espacos[0].id);
        } else {
          setEspacoSelecionado(undefined);
        }

      } else {
        setErro("Não foi possível buscar as quadras. Contate o Administrador");
        setEspacos([]);
      }

      setFetching(false);
    }

    getEspacos();

  }, [deletedEspaco]);

  useEffect(() => {
    if (addedEspaco) {      

      const getEspacos = async () => {

        setFetching(true);

        const response = await fetchEspacos();
        if (response.ok) {
          const espacos = response.data;
          setEspacos(espacos);
          setEspacoSelecionado(addedEspaco);
        } else {
          setErro("Não foi possível buscar as quadras. Contate o Administrador");
          setEspacos([]);
        }

        setFetching(false);
      }
    
      getEspacos();

    }
  }, [addedEspaco]);

  useEffect(() => {
    if (updatedEspacos.length > 0) {      

      const getEspacos = async () => {

        setFetching(true);

        const response = await fetchEspacos();
        if (response.ok) {
          const espacos = response.data;
          setEspacos(espacos);
        } else {
          setErro("Não foi possível buscar as quadras. Contate o Administrador");
          setEspacos([]);
        }

        setFetching(false);
      }
    
      getEspacos();

    }
  }, [updatedEspacos]);

    const handleAcceptTerms = async () => {
    try {
      const hoje = new Date().toISOString();

      // Obtém o IP público do usuário
      let ipUsuario = "desconhecido";
      try {
        const ipResponse = await fetch("https://api.ipify.org?format=json");
        if (ipResponse.ok) {
          const data = await ipResponse.json();
          ipUsuario = data.ip;
        }
      } catch (err) {
        console.warn("Não foi possível obter o IP do usuário:", err);
      }

      // Atualiza no backend
      const response = await updateEmpresa(empresaId, { 
        dataAssinatura: hoje,
        ipAssinatura: ipUsuario
      }); 

      if (response.ok) {
        setDadosEmpresa(prev => ({ ...prev, dataAssinatura: hoje, ipAssinatura: ipUsuario }));
        setShowTermsPopup(false);
      } else {
        setErro("Erro ao registrar aceite dos termos. Tente novamente.");
      }
    } catch (e) {
      setErro("Erro inesperado ao registrar aceite dos termos.");
    }
  }


  const viewProps = {
    espacos,
    espacoSelecionado,
    setErro,
    setView,
    fetchingEspacos: fetching,
    ...props
  }

  if (dadosEmpresa?.acesso === 'bloqueado') {
    return <Paper>
      <Alert severity='warning'>
          {"Seu acesso foi bloqueado por falta de pagamento. Regularize o pagamento e contate o administrador."}
        </Alert>
    </Paper>
  }

  if (dadosEmpresa && dadosEmpresa?.acesso !== 'gobeach') {
    return <Paper>
      <Alert severity='warning'>
          {"Acesso transferido! Acesse com o mesmo usuário e senha em "}
          <a href="https://www.reservei.online/home">{"www.reservei.online/home"}</a>
        </Alert>
    </Paper>
  }

  return <>
    <Paper className={classes.espacos}>
      <Fetching isFetching={fetching}>
        <LinkUtilities/>
        {dadosEmpresa && !dadosEmpresa.recipientId && <Alert severity='warning' className={classes.warning}>
          {"Para permitir reservas, informe seus dados bancários em "}
          <a href="/configuracoes">{"configurações"}</a>
        </Alert>}
        <Espacos
          espacos={espacos}
          espacoSelecionado={espacoSelecionado}
          setEspacoSelecionado={setEspacoSelecionado}
          setAddedEspaco={setAddedEspaco}
          setDeletedEspaco={setDeletedEspaco}
          updatedEspacos={updatedEspacos}
          setUpdatedEspacos={setUpdatedEspacos}
          setErro={setErro}
          { ...props }
        />
      </Fetching>
    </Paper>
    <Paper>
      {view === "agenda" && <Agenda { ...viewProps } />}
      {view === "horarios" && <HorariosDisponiveis { ...viewProps } />}
    </Paper>
    <Snackbar message={erro} onClose={limpaErro} />

        {/* Popup de aceite de termos */}
    <Dialog open={showTermsPopup} onClose={() => {}} disableBackdropClick disableEscapeKeyDown>
      <DialogTitle>Atualização dos Termos e Condições</DialogTitle>
      <DialogContent>
        <DialogContentText>
          Atualizamos nossos termos e condições de uso.  
          Para continuar utilizando o sistema, é necessário ler e aceitar os novos termos.  
          <br/><br/>
          Você deve aceitar os termos até <strong>31/08</strong>.  
          <br/><br/>
          <Link href="/termos/termos.pdf" target="_blank" rel="noopener">
            Clique aqui para visualizar os Termos e Condições (PDF)
          </Link>
        </DialogContentText>

        <FormControlLabel
          control={
            <Checkbox
              checked={accepted}
              onChange={e => setAccepted(e.target.checked)}
              color="primary"
            />
          }
          label="Declaro que li e concordo com os termos e condições de uso."
        />
      </DialogContent>
      <DialogActions>
        {new Date() <= new Date("2025-08-31T23:59:59") && (
          <Button
            onClick={() => setShowTermsPopup(false)}
            color="secondary"
          >
            Adiar
          </Button>
        )}

        <Button
          color="primary"
          onClick={handleAcceptTerms}
          disabled={!accepted}
        >
          Aceito
        </Button>
      </DialogActions>
    </Dialog>

  </>
}
